import { render, staticRenderFns } from "./rfq-file-posting.vue?vue&type=template&id=68327fdc&"
import script from "./rfq-file-posting.vue?vue&type=script&setup=true&lang=js&"
export * from "./rfq-file-posting.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports